import { CurrencyCode } from '@liveauctioneers/hammer-ui-liveauctioneers/lotDetail';

import { MessageScrollerContainer } from '../MessageScrollerContainer/MessageScrollerContainer';
import { BidPanel } from './components/BidPanel/BidPanel';
import { ItemDetails } from './components/ItemDetails/ItemDetails';

type Props = {
    catalogId: number;
    itemId: number;
    isThreeColumn: boolean;
    selectedCurrency?: CurrencyCode;
};

export const BiddingConsoleMiddleSection = ({ catalogId, itemId, isThreeColumn, selectedCurrency }: Props) => {
    return (
        <div className="grid h-[calc(100vh-64px)] grid-rows-[1fr_min-content] rounded-sm border border-border-secondary">
            <div className="flex min-h-0 flex-col overflow-hidden">
                <div className="flex min-h-0 flex-1 flex-col overflow-hidden">
                    <ItemDetails itemId={itemId} />
                </div>
                {!isThreeColumn && (
                    <div className="relative min-h-[149px] shrink-0 bg-background-primary">
                        <MessageScrollerContainer
                            catalogId={catalogId}
                            className="rounded-none border-x-0 border-b-0 border-t-[1px]"
                            headerless
                        />
                    </div>
                )}
            </div>
            <BidPanel
                itemId={itemId}
                selectedCurrency={selectedCurrency}
            />
        </div>
    );
};
